import { init } from "@fullstory/browser";
import React, { useEffect } from "react";

export interface FullstorySetupProps {
  children?: React.ReactNode | undefined;
}

export const FullstorySetup = ({ children }: FullstorySetupProps) => {
  useEffect(() => {
    init({
      orgId: "o-1VMFTK-na1",
      namespace: "FS",
      recordCrossDomainIFrames: true,
    });
  }, []);
  return <>{children}</>;
};
